import { loaderProps } from './loader.props';
import './loader.css';

function Loader({ color, width, height }: loaderProps) {
  return (
    <div className="loading flex items-center justify-center mb-3">
      <div
        style={{
          background: color && color,
          width: width && width,
          height: height && height,
        }}
      />
      <div
        style={{
          background: color && color,
          width: width && width,
          height: height && height,
        }}
      />
      <div
        style={{
          background: color && color,
          width: width && width,
          height: height && height,
        }}
      />
    </div>
  );
}

export default Loader;
